import { each, isEmpty, toInteger, toNumber } from 'lodash';
import { OffTypeEnum, OrderSwapBuyStatusEnum, ProductRelationEnum, ProductTypeEnum, UsePromoCodeStatusEnum, } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
import { COMBOS } from '../constant';
/**
 * 整单换购活动
 * 一个门店只会有一个换购物活动
 * @param opt
 * @returns
 */
export default function calOrderSwapBuy(opt) {
    var _a, _b, _c;
    let { usePromoCodeStatus, orderPrice } = opt;
    const { orderSwapBuyProducts, itemMap, products, enablePromoCodeActivity, orderSwapBuyActivitys } = opt;
    const orderSwapBuyActivity = orderSwapBuyActivitys[0];
    if (orderSwapBuyActivity) {
        // 不存在的
        orderSwapBuyActivity.orderPrice = 0;
        if (orderSwapBuyActivity.productRelation === ProductRelationEnum.All &&
            orderSwapBuyActivity.productComboRelation === ProductRelationEnum.All) {
            orderSwapBuyActivity.orderPrice = orderPrice;
        }
        else {
            each(products, (product) => {
                var _a, _b;
                const findProduct = findActivityProduct(orderSwapBuyActivity.productMap, product);
                if ((orderSwapBuyActivity.productRelation === ProductRelationEnum.All &&
                    product.type === ProductTypeEnum.Product) ||
                    (orderSwapBuyActivity.productComboRelation === ProductRelationEnum.All && COMBOS.includes(product.type)) ||
                    (findProduct &&
                        ((orderSwapBuyActivity.productRelation === ProductRelationEnum.Included &&
                            product.type === ProductTypeEnum.Product) ||
                            (orderSwapBuyActivity.productComboRelation === ProductRelationEnum.Included &&
                                COMBOS.includes(product.type)))) ||
                    (!findProduct &&
                        ((orderSwapBuyActivity.productRelation === ProductRelationEnum.Excluded &&
                            product.type === ProductTypeEnum.Product) ||
                            (orderSwapBuyActivity.productComboRelation === ProductRelationEnum.Excluded &&
                                COMBOS.includes(product.type))))) {
                    const id = product.pk || product.productNo + '_' + product.scaleNo;
                    let productOff = 0;
                    if (itemMap[id]) {
                        productOff = (((_a = itemMap[id]) === null || _a === void 0 ? void 0 : _a.itemAllOff) || 0) + (((_b = itemMap[id].apportion) === null || _b === void 0 ? void 0 : _b.off) || 0);
                    }
                    orderSwapBuyActivity.orderPrice =
                        orderSwapBuyActivity.orderPrice +
                            (orderSwapBuyActivity.isIncludeModifier ? product.productAndModifierPrice : product.price) *
                                ((product === null || product === void 0 ? void 0 : product.cnt) || 1) -
                            productOff;
                }
            });
            orderSwapBuyActivity.orderPrice = toFixed(orderSwapBuyActivity.orderPrice);
        }
    }
    const joinOrderSwapBuyProductMap = {};
    if (orderSwapBuyActivity) {
        const maxSwapCnt = toInteger(((_a = orderSwapBuyActivity === null || orderSwapBuyActivity === void 0 ? void 0 : orderSwapBuyActivity.extra) === null || _a === void 0 ? void 0 : _a.maxSwapCnt) || 0);
        orderSwapBuyActivity.maxSwapCnt = maxSwapCnt;
        orderSwapBuyActivity.surplusCnt = maxSwapCnt;
        const activityOrderFee = ((_b = orderSwapBuyActivity.extra) === null || _b === void 0 ? void 0 : _b.swapProducts[0].orderFee) || orderSwapBuyActivity.orderFee;
        // 还差多少钱
        orderSwapBuyActivity.buyAgainFee = toFixed(activityOrderFee - orderSwapBuyActivity.orderPrice);
        // const swapProduct = orderBy(orderSwapBuyActivity.extra?.swapProduct, 'orderFee', 'desc');
        let swapProducts;
        let swapOrderFee = activityOrderFee;
        let activityProductMap = orderSwapBuyActivity.productMap;
        each((_c = orderSwapBuyActivity === null || orderSwapBuyActivity === void 0 ? void 0 : orderSwapBuyActivity.extra) === null || _c === void 0 ? void 0 : _c.swapProducts, (sProduct) => {
            if (sProduct.orderFee <= orderSwapBuyActivity.orderPrice) {
                swapProducts = sProduct.products;
                swapOrderFee = sProduct.orderFee;
            }
        });
        orderSwapBuyActivity.orderFee = swapOrderFee;
        orderSwapBuyActivity.products = swapProducts;
        if (!isEmpty(swapProducts)) {
            activityProductMap = {};
            each(swapProducts, (sp) => {
                sp.activityPrice = toNumber(sp.activityPrice);
                activityProductMap[sp.productNo + '_' + sp.scaleNo] = sp;
            });
        }
        if (orderSwapBuyActivity.buyAgainFee <= 0) {
            orderSwapBuyActivity.buyAgainFee = 0;
            if (orderSwapBuyActivity.promoCode) {
                if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                    usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                }
                enablePromoCodeActivity.push(orderSwapBuyActivity.activityId);
            }
        }
        if (orderSwapBuyProducts.length > 0) {
            let joinCnt = 0; // 参与换购物的数量
            // 订单满足金额
            if (orderSwapBuyActivity.buyAgainFee <= 0) {
                // 换购生效
                each(orderSwapBuyProducts, (orderSwapBuyProduct) => {
                    orderSwapBuyProduct.orderSwapBuyStatus = OrderSwapBuyStatusEnum.Ineffective;
                    const id = orderSwapBuyProduct.pk || orderSwapBuyProduct.productNo + '_' + orderSwapBuyProduct.scaleNo;
                    const findSwapProduct = findActivityProduct(activityProductMap, orderSwapBuyProduct);
                    const joinOrderSwapBuyProductCnt = orderSwapBuyProduct.cnt || 0;
                    if (findSwapProduct && joinCnt < maxSwapCnt && joinCnt + joinOrderSwapBuyProductCnt <= maxSwapCnt) {
                        if (!joinOrderSwapBuyProductMap[id] && (findSwapProduct.cnt || 0) >= joinOrderSwapBuyProductCnt) {
                            findSwapProduct.cnt = (findSwapProduct.cnt || 0) - joinOrderSwapBuyProductCnt;
                            joinOrderSwapBuyProductMap[id] = orderSwapBuyProduct;
                            joinCnt += (orderSwapBuyProduct === null || orderSwapBuyProduct === void 0 ? void 0 : orderSwapBuyProduct.cnt) || 0;
                            orderSwapBuyProduct.orderSwapBuyStatus = OrderSwapBuyStatusEnum.Effective;
                            const itemAllOff = toFixed((orderSwapBuyProduct.price - findSwapProduct.activityPrice) * (orderSwapBuyProduct.cnt || 1));
                            orderSwapBuyProduct.off = itemAllOff;
                            orderSwapBuyProduct.offTip = orderSwapBuyActivity.activityName;
                            orderSwapBuyProduct.offId = orderSwapBuyActivity.activityId;
                            (orderSwapBuyProduct.offType = orderSwapBuyActivity.promoCode
                                ? OffTypeEnum.PromoCode
                                : OffTypeEnum.Activity),
                                (itemMap[id] = {
                                    items: [orderSwapBuyProduct],
                                    itemAllOff: itemAllOff,
                                });
                            orderPrice = toFixed(((findSwapProduct.activityPrice || 0) + ((orderSwapBuyProduct === null || orderSwapBuyProduct === void 0 ? void 0 : orderSwapBuyProduct.modifierPrice) || 0)) *
                                (orderSwapBuyProduct.cnt || 1) +
                                orderPrice);
                            products.push(orderSwapBuyProduct);
                        }
                    }
                });
            }
            else {
                each(orderSwapBuyProducts, (orderSwapBuyProduct) => {
                    orderSwapBuyProduct.orderSwapBuyStatus = OrderSwapBuyStatusEnum.Ineffective;
                });
            }
            orderSwapBuyActivity.surplusCnt = maxSwapCnt - joinCnt;
        }
    }
    else {
        each(orderSwapBuyProducts, (orderSwapBuyProduct) => {
            orderSwapBuyProduct.orderSwapBuyStatus = OrderSwapBuyStatusEnum.Ineffective;
            const id = orderSwapBuyProduct.pk || orderSwapBuyProduct.productNo + '_' + orderSwapBuyProduct.scaleNo;
            joinOrderSwapBuyProductMap[id] = orderSwapBuyProduct;
        });
    }
    return { usePromoCodeStatus, orderPrice, joinOrderSwapBuyProductMap, orderSwapBuyActivity };
}
//# sourceMappingURL=calOrderSwapBuy.js.map